import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import { analyticsMiddleware } from '../features/analytics/analytics-middleware';
import rootReducer from './root-reducer';

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(analyticsMiddleware),
});

if (process.env.NODE_ENV === 'development' && (module as any).hot) {
  (module as any).hot.accept('./root-reducer', () => {
    store.replaceReducer(rootReducer);
  });
}

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

// eslint-disable-next-line import/no-default-export
export default store;
